//--------------Utils---------------------
import { fetchRequest } from "../utils";

//--------------Helpers--------------------
import { responseHandler } from "../helpers";

export const refreshToken = async () => {
  localStorage.setItem("accessToken", "");

  const response = await fetchRequest("api/refresh/admin", "GET");

  const error = responseHandler(response);
  //
  if (!error) {
    localStorage.setItem("accessToken", response.accessToken);
    return true;
  } else {
    localStorage.removeItem("accessToken");
    window.dispatchEvent(new Event("storage"));
  }
};
